import axios, { AxiosResponse } from "axios";
import { ILoggingAPIBody } from "../types/LoggingTypes";
import AxiosRequest from "../../../api/api";

export default async(url:string, body: ILoggingAPIBody, token: string): Promise<AxiosResponse> => {
    return AxiosRequest(url, 'POST', body, token);
};